import { createContext } from "react";
import type { AnthropometricMetadataStore } from "../AnthropometricMetadataProvider.types";

const AnthropometricMetadataStoreContext = createContext<AnthropometricMetadataStore | undefined>(undefined);
AnthropometricMetadataStoreContext.displayName = "AnthropometricMetadataStoreContext";

export default AnthropometricMetadataStoreContext;
